import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FooterCopyright from '../../components/footer/FooterCopyright';
import FooterNewsletter from '../../components/footer/FooterNewsletter';

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  spaceLeftClass,
  spaceRightClass,
  containerClass,
  extraFooterClass,
  sideMenu,
}) => {
  const {t} =  useTranslation();
  return (
    <footer
      className={clsx(
        'footer-area',
        backgroundColorClass,
        spaceTopClass,
        spaceBottomClass,
        extraFooterClass,
        spaceLeftClass,
        spaceRightClass
      )}
    >
      <div className={`${containerClass ? containerClass : 'container'}`}>
        <div className="row">
          <div
            className={`${
              sideMenu ? 'col-xl-12 col-sm-12' : 'col-lg-12 col-sm-12'
            } d-flex justify-content-center`}
          >
            <p className="mb-0" style={{ color: 'var(--neutral-19)' }}>
              made by{' '}
              <a
                href="https://www.mpstyle.it/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--neutral-19)', textDecoration: 'underline' }}
              >
                MpStyle
              </a>
            </p>
            {/* footer copyright */}
            {/*]
            <FooterCopyright
              footerLogo="/assets/img/logo/logo.png"
              //spaceBottomClass="mb-0"
            />
            */}
          </div>
          {/*
          <div
            className={`${
              sideMenu ? 'col-xl-2 col-sm-4' : 'col-lg-2 col-sm-4'
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3>{t("ABOUT US")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>{t("About us")}</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>
                      {t("Store location")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>{t("Contact")}</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>
                      {t("Orders tracking")}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
            */}
          {/*  
          <div
            className={`${
              sideMenu ? 'col-xl-2 col-sm-4' : 'col-lg-2 col-sm-4'
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? 'footer-widget mb-30 ml-95'
                  : 'footer-widget mb-30 ml-50'
              }`}
            >
              <div className="footer-title">
                <h3>{t("USEFUL LINKS")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>{t("Returns")}</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>
                      {t("Support Policy")}
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>{t("Size guide")}</Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + '#/'}>{t("FAQs")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? 'col-xl-3 col-sm-4' : 'col-lg-2 col-sm-6'
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? 'footer-widget mb-30 ml-145'
                  : 'footer-widget mb-30 ml-75'
              }`}
            >
              <div className="footer-title">
                <h3>{t("FOLLOW US")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  <li>
                    <a
                      href="//www.facebook.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Facebook")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="//www.twitter.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Twitter")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="//www.instagram.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Instagram")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="//www.youtube.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("Youtube")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
            */}
          {/*  
          <div
            className={`${
              sideMenu ? 'col-xl-3 col-sm-8' : 'col-lg-4 col-sm-6'
            }`}
          >
            
            
            <FooterNewsletter
              spaceBottomClass="mb-30"
              spaceLeftClass="ml-70"
              sideMenu={sideMenu}
            />
            
          </div>
          */}
        </div>
      </div>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
  spaceLeftClass: PropTypes.string,
  spaceRightClass: PropTypes.string,
};

export default FooterOne;
